import React, { useEffect, useState } from "react";
import { VALIDATIONS, VALIDATIONS_TEXT } from "../../../app-constants";
import { Button, Form } from "react-bootstrap";
import { useForm } from "react-hook-form";
import axios from "axios";
import TekLoader from "../../images/Tek-Spinner.gif";

function Downloadform(props) {

  const getBaseUrl = () => {
    if (
      typeof window !== "undefined" &&
      (window.location.href.includes(
        "https://staging-tekrevol.tekstagearea.com"
      ) ||
        window.location.href.includes("http://localhost:8000") ||
        window.location.href.includes("http://localhost:9000"))
    ) {
      return "https://tekrevol-form.tekstagearea.com/contact-form.php";
    } else {
      // return "https://tekrevol.tekstagearea.com/api/v1/contact-form";
      return "https://tekrevol-form.tekstagearea.com/contact-form.php";
    }
  };


  const {
    register,
    handleSubmit,
    watch,
    reset,
    formState: { errors },
  } = useForm({
    mode: "onChange",
  });
  const [Success, SetSuccess] = useState(false);
  const [Loading, SetLoading] = useState(false);
  const onSubmit = async (data) => {
    const url = window.location.href;
    data.form_path = url.split("?")[0];
    SetLoading(true);

    const baseUrl = getBaseUrl(); // Get the base URL
    const response = await axios.post(baseUrl, data);
    
    // const response = await axios.post(
    //   `https://tekrevol.tekstagearea.com/api/v1/contact-form`,
    //   data
    // );

    SetSuccess(true);
    setTimeout(() => {
      SetSuccess(false);
    }, 2000);
    SetLoading(false);
    props.setShow(false);
    reset({
      name: "",
      email: "",
      company: "",
    });
    window.open(
      "https://d3r5yd0374231.cloudfront.net/images-tek/assets/pdf/Sustainable-Healthcare-Mobile-Apps-&-The-Connected-Ecosystem.pdf",
      "_blank"
    );
  };
  return (
    <div className="banner_form">
      <span className="sub_title">GET A FREE COPY</span>
      <h3>
        Download this ebook <span>in PDF format</span>
      </h3>
      <Form
        className="banner_form_inner"
        onSubmit={handleSubmit(onSubmit)}
        method="POST"
      >
        <Form.Group className="from_item">
          <Form.Control
            type="text"
            placeholder="Full Name"
            name="name"
            {...register("name", {
              pattern: {
                value: /^[A-Za-z\s]+$/,
                message: VALIDATIONS_TEXT.NAME_INVALID,
              },
              maxLength: {
                value: VALIDATIONS.NAME,
                message: VALIDATIONS_TEXT.NAME_MAX,
              },
              required: {
                value: true,
                message: VALIDATIONS_TEXT.NAME_REQUIRED,
              },
            })}
          />
          {errors.name && (
            <span className="error_tek">{errors.name?.message}</span>
          )}
        </Form.Group>
        <Form.Group className="from_item">
          <Form.Control
            type="email"
            placeholder="Email"
            name="email"
            {...register("email", {
              maxLength: {
                value: VALIDATIONS.EMAIL,
                message: VALIDATIONS_TEXT.EMAIL_MAX,
              },
              required: {
                value: true,
                message: VALIDATIONS_TEXT.EMAIL_REQUIRED,
              },
              pattern: {
                value: /\S+@\S+\.\S+/,
                message: VALIDATIONS_TEXT.EMAIL_FORMAT,
              },
            })}
          />
          {errors.email && (
            <span className="error_tek">{errors.email?.message}</span>
          )}
        </Form.Group>
        <Form.Group className="from_item">
          <Form.Control
            type="text"
            placeholder="Company Name"
            name="company"
            {...register("company", {
              maxLength: {
                value: VALIDATIONS.NAME,
                message: VALIDATIONS_TEXT.NAME_MAX,
              },
              required: {
                value: true,
                message: VALIDATIONS_TEXT.NAME_REQUIRED,
              },
            })}
          />
          {errors.company && (
            <span className="error_tek">{errors.company?.message}</span>
          )}
        </Form.Group>

        {!Loading ? (
          <Button variant="primary" className="btn_submit" type="submit">
            Download
          </Button>
        ) : (
          <img
            src={TekLoader}
            alt="img_looder"
            className="img-fluid looder_img"
          />
        )}
      </Form>
      {Success ? (
        <div className="alert-success">
          Thank you for your message. It has been sent.
        </div>
      ) : (
        ""
      )}
    </div>
  );
}

export default Downloadform;
